import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';

interface IAgreementTermOfExecutionAgreementCell {
  termOfExecutionAgreement: string[];
}

export function AgreementTermOfExecutionAgreementCell<T extends IAgreementTermOfExecutionAgreementCell>({
  row,
}: Readonly<ITableRenderCell<T>>) {
  return (
    <div>
      {row.termOfExecutionAgreement
        .map(i => formatDate({ date: i || '', dateFormat: DATE_FORMAT_LONG_FNS }))
        .join(', ')}
    </div>
  );
}
